module.exports = __webpack_public_path__ + "static/media/logex.19543e50.png";